var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "one-column-layout",
    {
      attrs: { title: "Experiences" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [_c("Header")]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      [
        _c("div", [
          _c(
            "div",
            {
              staticClass: "row no-gutters mb-3",
              style: _vm.isMobile ? "margin-top: 150px" : ""
            },
            [
              _c("div", { staticClass: "col-7 col-md-9 filter-panel" }, [
                _c("div", { staticClass: "filter-control" }, [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex justify-content-between",
                      on: { click: _vm.onOpenCloseFilter }
                    },
                    [
                      _c("div", [
                        _c(
                          "a",
                          {
                            staticClass: "text-secondary",
                            attrs: { href: "javascript:void(0)" }
                          },
                          [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.isMobile ? "Filtra" : "Filtra risultati"
                                )
                              )
                            ]),
                            _c("span", [_vm._v(" | " + _vm._s(_vm.counter))])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-secondary mr-2",
                            on: { click: _vm.onResetFilter }
                          },
                          [_vm._v("reset")]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      on: {
                        mouseleave: function($event) {
                          _vm.openFilter = false
                        }
                      }
                    },
                    [
                      _c("DropdownFilterExperience", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.openFilter,
                            expression: "openFilter"
                          }
                        ],
                        attrs: { list: _vm.list, value: _vm.filter },
                        on: { change: _vm.onChangeFilter }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pl-3 col-5 col-md-3" },
                [
                  _c("CustomOrderSelect", {
                    staticClass: "lg gray",
                    attrs: { list: _vm.orders, value: _vm.order },
                    on: { change: _vm.onChangeOrder }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            _vm._l(_vm.listFiltered, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  ref: "listRef",
                  refInFor: true,
                  staticClass: "mb-3"
                },
                [
                  _c("HorizontalItemExperience", {
                    attrs: { value: item, search: _vm.search },
                    on: { select: _vm.onSelect }
                  })
                ],
                1
              )
            }),
            0
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d123d46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d123d46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/ExperienceSelection.vue
// module id = null
// module chunks = 